module.exports = __webpack_public_path__ + "img/24.9d497de0.jpg";